import { IMarkerConfig, ILineConfig, IPolygonConfig } from '../types';

export interface IMapCommand {
  readonly id: string;
  readonly type: MapCommandType;
  readonly timestamp: number;
  readonly description: string;

  execute(): void;
  undo(): void;
  canExecute(): boolean;
  canUndo(): boolean;
}

export enum MapCommandType {
  ADD_MARKER = 'ADD_MARKER',
  REMOVE_MARKER = 'REMOVE_MARKER',
  UPDATE_MARKER = 'UPDATE_MARKER',
  ADD_LINE = 'ADD_LINE',
  REMOVE_LINE = 'REMOVE_LINE',
  UPDATE_LINE = 'UPDATE_LINE',
  ADD_POLYGON = 'ADD_POLYGON',
  REMOVE_POLYGON = 'REMOVE_POLYGON',
  UPDATE_POLYGON = 'UPDATE_POLYGON',
  CLEAR_ALL = 'CLEAR_ALL',
  BATCH = 'BATCH',
}

export interface IMarkerCommandData {
  marker: IMarkerConfig;
  previousMarker?: IMarkerConfig;
}

export interface ILineCommandData {
  line: ILineConfig;
  previousLine?: ILineConfig;
}

export interface IPolygonCommandData {
  polygon: IPolygonConfig;
  previousPolygon?: IPolygonConfig;
}

export interface IClearCommandData {
  previousState: {
    markers: IMarkerConfig[];
    lines: ILineConfig[];
    polygons: IPolygonConfig[];
  };
}

export interface IBatchCommandData {
  commands: IMapCommand[];
}

export interface IHistoryState {
  undoStack: IMapCommand[];
  redoStack: IMapCommand[];
  maxHistorySize: number;
  isEnabled: boolean;
}

export interface IHistoryManager {
  readonly isEnabled: boolean;
  readonly canUndo: boolean;
  readonly canRedo: boolean;
  readonly undoCount: number;
  readonly redoCount: number;

  enable(): void;
  disable(): void;
  clear(): void;

  executeCommand(command: IMapCommand): void;
  undo(): boolean;
  redo(): boolean;

  getUndoDescription(): string | null;
  getRedoDescription(): string | null;
}

export interface IHistoryConfig {
  enabled?: boolean;
  maxHistorySize?: number;
  enableKeyboardShortcuts?: boolean;
  enableBatchCommands?: boolean;
}
